// extracted by mini-css-extract-plugin
export default {"container":"styles_container__zg4eL","tabContainer":"styles_tabContainer__Xv5Dl"};